export default __webpack_public_path__ + "../images/slider-2.png";